import { c as _c } from "react/compiler-runtime";
import type { ButtonProps } from '@petsmart-ui/sparky';
import { Button } from '@petsmart-ui/sparky';
import Link from 'next/link';
export type IButtonProps = ButtonProps & {
  isNextLink?: boolean;
};
export function GenericButton(t0) {
  const $ = _c(14);
  let href;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      isNextLink: t1,
      href,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = href;
    $[2] = props;
    $[3] = t1;
  } else {
    href = $[1];
    props = $[2];
    t1 = $[3];
  }
  const isNextLink = t1 === undefined ? false : t1;
  const hasValidHref = typeof href === "string" && href.trim().length > 0;
  const buttonProps = props as ButtonProps;
  if (isNextLink && hasValidHref) {
    let t2;
    if ($[4] !== buttonProps) {
      t2 = <Button {...buttonProps} />;
      $[4] = buttonProps;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    let t3;
    if ($[6] !== href || $[7] !== t2) {
      t3 = <Link href={href} prefetch={false}>{t2}</Link>;
      $[6] = href;
      $[7] = t2;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    return t3;
  }
  if (hasValidHref) {
    let t2;
    if ($[9] !== buttonProps || $[10] !== href) {
      t2 = <Button href={href} {...buttonProps} />;
      $[9] = buttonProps;
      $[10] = href;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    return t2;
  }
  let t2;
  if ($[12] !== buttonProps) {
    t2 = <Button {...buttonProps} />;
    $[12] = buttonProps;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
}